import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import { PageTemplate } from "../../components/PageTemplate";
import type { HomePageTemplate } from "../../types/homePageTemplate";
import homeData from "../../data/pages/home.json";
import { resolveCdnAssetUrl } from "../../utils/cdnAssetUrl";
import { resolveAssetUrl } from "../../utils/resolveAssetUrl";
import { MdaiDivider } from "../../components/MdaiDivider";
import { Solutions } from "./Solutions";

const typedHomeData = homeData as HomePageTemplate;
const SMART_HUB_ARCH_URL = resolveCdnAssetUrl("home/arch-overview.svg");
const SMART_HUB_VIDEO_URL = resolveCdnAssetUrl("home/smart-hub-e2e.mp4");

const BOTTOM_CTAS = [
  { text: "Dive into the platform", href: "https://demo.mydecisive.ai/", variant: "contained" as const },
  { text: "Try it now", href: "https://mydecisive.github.io/octant-ui/", variant: "outlined" as const },
  { text: "What's the ROI?", href: "https://mydecisive.github.io/roi-calculator/", variant: "text" as const },
];

export default function HomePage(): ReactElement {
  const heroButtons = typedHomeData.hero.buttons.map((button) => ({
    ...button,
  }));

  return (
    <Box pt={{ sm: 0, lg: 0 }}>
      <PageTemplate
        id="home"
        hero={{
          title: typedHomeData.hero.title,
          titleFlip: true,
          titleVariant: "h1",
          image: {
            src: resolveAssetUrl(typedHomeData.hero.image.src),
            alt: typedHomeData.hero.image.alt,
            width: 365,
            href: typedHomeData.hero.image.href,
            caption: typedHomeData.hero.image.caption,
            aspectRatio: "auto",
          },
          subtitle: typedHomeData.hero.subtitle,
          buttons: heroButtons,
          divider: false,
        }}
        topTabs={{
          headline: "Octant + SmartHub by MyDecisive",
          button: false,
          caption: (
            <>
              {typedHomeData.smarthubIntro.body.map((paragraph, index) => (
                <Typography
                  key={paragraph}
                  variant="subtitle2"
                  textAlign={{ sm: "center", lg: "left" }}
                  marginBottom={index < typedHomeData.smarthubIntro.body.length - 1 ? { lg: 4 } : undefined}
                >
                  {paragraph}
                </Typography>
              ))}
            </>
          ),
          tabs: [
            {
              alt: "MyDecisive SmartHub",
              src: SMART_HUB_ARCH_URL,
              title: "Conceptual",
              type: "image",
            },
            {
              src: SMART_HUB_VIDEO_URL,
              title: "Physical",
              type: "video",
            },
          ],
        }}
        sections={
          <>
            <Solutions />
            <MdaiDivider />
            <Stack
              direction={{ sm: "column", md: "row" }}
              alignItems={{ sm: "center", md: "flex-start" }}
              justifyContent="center"
              spacing={2}
              sx={{ pb: 8 }}
            >
              {BOTTOM_CTAS.map(({ text, href, variant }) => (
                <Button key={text} variant={variant} href={href} target="_blank" rel="noopener noreferrer">
                  {text}
                </Button>
              ))}
            </Stack>
          </>
        }
      />
    </Box>
  );
}
